import api from "./api";

const BASE = "/v1/rbac";

const getAllUsers = () =>
  api.get(`${BASE}/users`).then((r) => (r.data && r.data.data) || []);
const updateUserRole = (id, payload) =>
  api.put(`${BASE}/users/${id}/role`, payload).then((r) => r.data);
const getRoleDefinitions = () =>
  api.get(`${BASE}/roles`).then((r) => (r.data && r.data.data) || {});
const updateUserModules = (id, payload) =>
  api.put(`${BASE}/users/${id}/modules`, payload).then((r) => r.data);
const getModuleOptions = () =>
  api.get(`${BASE}/modules`).then((r) => (r.data && r.data.data) || []);
const updateUserStatus = (id, payload) =>
  api.put(`${BASE}/users/${id}/status`, payload).then((r) => r.data);

export default {
  getAllUsers,
  updateUserRole,
  getRoleDefinitions,
  updateUserModules,
  getModuleOptions,
  updateUserStatus,
};
